<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <!-- Mobile toggle button -->
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>

        <!-- Desktop toggle button -->
        <VaButton
          v-if="!isMobile"
          preset="plain"
          :icon="isSidebarMinimized ? 'menu' : 'menu_open'"
          color="primary"
          size="small"
          class="sidebar-toggle-btn"
          @click="toggleSidebar"
        />

        <RouterLink :to="roleLandingPage" aria-label="Visit home page">
          <VuesticLogo />
        </RouterLink>
      </div>
    </template>
    <template #center>
      <GlobalSearch :is-mobile="isMobile" class="app-navbar-search" />
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import GlobalSearch from './components/GlobalSearch.vue'
import VuesticLogo from '../VuesticLogo.vue'
import { getRoleLandingPage } from '../../utils/userRoleUtils'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)

const roleLandingPage = computed(() => getRoleLandingPage())

const toggleSidebar = () => {
  GlobalStore.toggleSidebar()
}
</script>

<style lang="scss" scoped>
.app-layout-navbar {
  background-color: #051436 !important;
}

.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}

/* Sidebar toggle button styles */
.sidebar-toggle-btn {
  margin-right: 0.5rem;
  transition: all 0.2s ease;
}

.sidebar-toggle-btn:hover {
  transform: scale(1.1);
}

.app-navbar-search {
  width: 100%;
  max-width: 32rem;
  margin: 0 1rem;
}

@media screen and (max-width: 950px) {
  .app-navbar-search {
    margin: 0 0.5rem;
    max-width: none;
  }
}
</style>
